import z from 'zod';

export enum StandardSubject {
  BIOLOGY = 'BIOLOGY',
  CHEMISTRY = 'CHEMISTRY',
  HISTORY = 'HISTORY',
  MATHEMATICS = 'MATHEMATICS',
  PHYSICS = 'PHYSICS',
  SCIENCE = 'SCIENCE',
}

export const standardSubjectSchema = z.enum(StandardSubject);
